import React from 'react';
import NavBarItem from './NavBarItem';
import ImageLink from './ImageLink';
import betaImage from '../resources/get-beta-100px.png';
import { ILogInType } from '../actions/LogInActions';
import { connect } from 'react-redux';
import { IState } from '../state/State';

export interface INavBarProps {
  logInState: ILogInType,
}

const NavBar: React.FC<INavBarProps> = (props: INavBarProps) => {
    let isUserLoggedIn: boolean = props.logInState.accessToken != null;

    let logInItem;
    let profileBody;
    if (isUserLoggedIn) {
      logInItem = <NavBarItem text="Log Out" linkTo="/logout" />
      profileBody = <td><NavBarItem text="Profile" linkTo="/profile" /></td>
    }
    else {
      logInItem = <NavBarItem text="Log In" linkTo="/login" />
    }

    return (
      <table className="NavBar">
        <tbody>
          <tr>
            {/* <td><ImageLink image={betaImage} link="https://www.rhythmhorizon.com/store/rhythm-horizon-beta-game-1-year-subscription" /></td> */}
            {/* <td><NavBarItem text="Home" linkTo="/home" /></td> */}
            {/* <td><NavBarItem text="News" linkTo="/news" /></td> */}
            {/* <td><NavBarItem text="About" linkTo="/about" /></td> */}
            <td><NavBarItem text="Stats" linkTo="/stats" /></td>
            {/* <td><NavBarItem text="Shop" linkTo="/shop" /></td> */}
            {profileBody}
            <td>{logInItem}</td>
          </tr>
        </tbody>
      </table>
    );
  }

  const mapStateToProps = (state: IState) => ({logInState: state.logIn.result});
  
  export default connect(mapStateToProps)(NavBar);
